import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface MarketSegmentationSectionProps {
  marketSegment: string;
  setMarketSegment: (value: string) => void;
  targetCustomerType: string;
  setTargetCustomerType: (value: string) => void;
}

export const MarketSegmentationSection = ({
  marketSegment,
  setMarketSegment,
  targetCustomerType,
  setTargetCustomerType,
}: MarketSegmentationSectionProps) => {
  return (
    <div className="space-y-4">
      <div>
        <Label>Report Angle</Label>
        <Select value={marketSegment} onValueChange={setMarketSegment}>
          <SelectTrigger>
            <SelectValue placeholder="Select report angle" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="Demographic">Demographic (e.g., age, income)</SelectItem>
            <SelectItem value="Behavioural">Behavioural (e.g., preferences)</SelectItem>
            <SelectItem value="Industry-Specific">Industry-Specific</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div>
        <Label className="flex items-center">
          Target Customer Type
          <span className="text-red-500 ml-1">*</span>
        </Label>
        <Select value={targetCustomerType} onValueChange={setTargetCustomerType}>
          <SelectTrigger>
            <SelectValue placeholder="Select customer type" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="B2B">B2B (businesses)</SelectItem>
            <SelectItem value="B2C">B2C (consumers)</SelectItem>
            <SelectItem value="Both">Both</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};